import { graphql, useStaticQuery } from "gatsby";
import React from "react";

export const Meta = ({
  type,
  title,
  description = "",
  keywords,
  imageUrl,
  imgsrc,
  url,
  noIndex,
  author,
  timeToRead,
}) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          subtitle
        }
      }
    }
  `);

  const metaTitle =
    title || `${site.siteMetadata.title} | ${site.siteMetadata.subtitle}`;
  const metaImage = imgsrc || imageUrl && `https:${imageUrl}?w=1200` || "https://assets.ustwo.com/images/misc/ustwo-generic-meta-image.png";

  return (
    <>
      <title>{metaTitle}</title>
      <meta name="description" content={description} />
      {keywords && (
        <meta
          name="keywords"
          content={keywords.toString().replace(/,/g, ", ")}
        />
      )}
      <meta name="image" content={metaImage} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:title" content={metaTitle} />
      <meta property="og:site_name" content={metaTitle} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:secure_url" content={metaImage} />
      <meta property="og:image:width" content="300" />
      <meta property="og:image:height" content="300" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={description || ""} />
      <meta name="twitter:image" content={metaImage} />
      <meta name="twitter:creator" content="ustwo" />
      {type === "blogPost" && (
        <>
          {author && (
            <>
              <meta name="twitter:label1" content="Written by" />
              <meta name="twitter:data1" content={author} />
              <meta name="author" content={author} />
            </>
          )}
          {timeToRead && (
            <>
              <meta name="twitter:label2" content="Est. reading time" />
              <meta name="twitter:data2" content={`${timeToRead} minutes`} />
            </>
          )}
        </>
      )}
      {/* gatsby-plugin-canonical-urls covers the following: <link rel="canonical" href={url} /> */}
      {noIndex && <meta name="robots" content="noindex, nofollow, noimageindex" />}
      {/* <script type="module" src="https://backspace.eco/b.js" /> */}
    </>
  );
};

export default Meta;

export const Head = () => <title>Hello World</title>

export const query = graphql`
  fragment MetaFields on ContentfulPage {
    title
    seoTitle
    seoDescription
    seoKeywords
    image {
      file {
        url
      }
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, quality: 70)
      title
      publicUrl
    }
  }
`;
